import * as React from "react";
import moment from "moment";

const SignedVersionList: React.FunctionComponent<{
  versions?: any[];
  onView?: (signedDocument: any) => void;
  title?: string;
  showAgreementExpiryDate?: boolean;
  hideClient?: boolean;
  hideVendor?: boolean;
}> = (props) => {
  return !!props.versions?.length ? (
    <>
      <div className="">
        <div className="table-responsive bg-white">
          <table className="table table-bordered w-100">
            <tr>
              <th className="font-sm font-weight-semibold">Version</th>
              <th className="font-sm font-weight-semibold">Uploaded By</th>
              <th className="font-sm font-weight-semibold">
                {props.title} Version
              </th>
              {!props.hideClient && (
                <>
                  {" "}
                  <th className="font-sm font-weight-semibold">
                    Client Acceptance & Agreed By
                  </th>
                  <th className="font-sm font-weight-semibold">
                    Date of Client Signed
                  </th>
                </>
              )}
              {!props.hideVendor && (
                <>
                  <th className="font-sm font-weight-semibold">
                    Vendor/ Owner Acceptance & Agreed By
                  </th>
                  <th className="font-sm font-weight-semibold">
                    Date of Vendor/ Owner Signed
                  </th>
                </>
              )}
              {props.showAgreementExpiryDate && (
                <>
                  <th className="font-sm font-weight-semibold">
                      Agreement Expiry Date
                  </th>
                </>
              )}
            </tr>
            {props?.versions?.map((version) => {
              return (
                <tr
                  onClick={() => props.onView?.(version)}
                  className="cursor-pointer"
                >
                  <td className="font-sm font-weight-semibold">
                    V{version.versionNumber || version.document?.versionNumber}
                  </td>
                  <td className="font-sm font-weight-semibold">
                    <div className="d-flex align-items-center">
                      {version.uploadedBy?.name}
                    </div>
                  </td>
                  <td className="font-sm font-weight-semibold">
                    {version.stageVersion && <>V{version.stageVersion}</>}
                  </td>
                  {!props.hideClient && (
                    <>
                      <td className="font-sm font-weight-semibold">
                        <div className="d-flex align-items-center">
                          {version.clientSignedBy?.fullName}
                        </div>
                      </td>
                      <td className="font-sm font-weight-semibold">
                        {version?.clientSignedAt && (
                          <>
                            {moment(version?.clientSignedAt).format(
                              "DD MMM YYYY hh:mm A"
                            )}{" "}
                          </>
                        )}
                      </td>
                    </>
                  )}
                  {!props.hideVendor && (
                    <>
                      <td className="font-sm font-weight-semibold">
                        <div className="d-flex align-items-center">
                          {version.landLordSignedBy?.fullName}
                        </div>
                      </td>
                      <td className="font-sm font-weight-semibold">
                        {version?.landLordSignedAt && (
                          <>
                            {moment(version?.landLordSignedAt).format(
                              "DD MMM YYYY hh:mm A"
                            )}{" "}
                          </>
                        )}
                      </td>
                    </>
                  )}
                    {props.showAgreementExpiryDate && (
                      <>
                         <td className="font-sm font-weight-semibold">
                          {version?.agreementExpiryDate && (
                            <>
                              {moment(version?.agreementExpiryDate).format(
                                "DD MMM YYYY"
                              )}{" "}
                            </>
                          )}
                        </td>
                        </>
                    )}
                </tr>
              );
            })}
          </table>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default SignedVersionList;
